import type { Cart, LanguageIsoCode, Program } from '@/graphql/graphql';
import { createContext, useContext } from 'react';

interface CartContextValue {
    cart: Cart | null;
    refreshCart: () => Promise<Cart | null>;
    canAddToCart: (programId: string, programLang: string) => Promise<boolean>;
    addToCart: (program: Program, lang: LanguageIsoCode) => Promise<void>;
}

export const CartContext = createContext<CartContextValue | null>(null);

export const useCart = (): CartContextValue => {
    const context = useContext(CartContext);
    if (!context) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};
